// Picks an invoice day (CF2): the contract date's day, the last day of the month, or a fixed day.
// `inherit` adds a first option that leaves the choice to the client's invoice table.

import { Select } from "@fluentui/react-components";
import { ordinal, type InvoiceDay } from "../../core";

const DAYS = Array.from({ length: 31 }, (_, i) => i + 1);

export function InvoiceDaySelect(props: { value: InvoiceDay | undefined; onChange: (v: InvoiceDay | undefined) => void; disabled?: boolean; inherit?: string; size?: "small" | "medium"; "aria-label"?: string }) {
  const value = props.value === undefined ? "" : String(props.value);
  return (
    <Select
      size={props.size}
      value={value}
      disabled={props.disabled}
      aria-label={props["aria-label"] ?? "Invoice day"}
      onChange={(_, d) => props.onChange(d.value === "" ? undefined : d.value === "contract" || d.value === "last" ? d.value : Number(d.value))}
    >
      {props.inherit !== undefined && <option value="">{props.inherit}</option>}
      <option value="contract">Contract date's day</option>
      <option value="last">Last day of the month</option>
      {DAYS.map((d) => (
        <option key={d} value={String(d)}>
          The {ordinal(d)}
        </option>
      ))}
    </Select>
  );
}
